import { root, folder, file, app, today } from './seed.js';
import { getFsMap, flattenTree } from './store.svelte.js';
import { virtualSearchNodes, buildVirtualSearchNodes, indexSearchNodes } from './search.js';
import { getNode } from './navigation.js';
import { touchFilesystem, rewritePaths } from './mutations.js';

export const FILESYSTEM_SCHEMA_VERSION = 1;

function ensureSystemNodes() {
  const applications = getNode('/Applications');
  const guest = getNode('/Users/Guest');
  const documents = getNode('/Users/Guest/Documents');
  const requiredApps = [
    ['TextEdit.app', 'document', 'textedit'], ['Preview.app', 'pdf-document', 'preview'],
    ['Terminal.app', 'terminal', 'terminal'], ['Safari.app', 'safari', 'safari'],
    ['Calculator.app', 'calculator', 'calculator'], ['Calendar.app', 'calendar', 'calendar'],
    ['Notes.app', 'notes', 'notes'], ['Stickies.app', 'stickies', 'stickies'],
    ['Weather.app', 'cloud', 'weather'], ['Contacts.app', 'address-book', 'contacts'],
    ['Messages.app', 'chat', 'chat'], ['QuickTime Player.app', 'quicktime', 'quicktime'],
    ['Gallery.app', 'gallery', 'gallery'], ['Activity Monitor.app', 'activity-monitor', 'activity-monitor'],
    ['Software Update.app', 'software-update', 'software-update'], ['AquaPaint.app', 'aquapaint', 'aquapaint'],
    ['Photos.app', 'image-file', 'photos'], ['Photo Booth.app', 'welcome', 'photobooth'],
    ['Freeform.app', 'freeform', 'freeform'], ['Journal.app', 'document', 'journal'],
    ['Books.app', 'pdf-document', 'books'], ['Screen Capture.app', 'computer', 'screen-capture'],
    ['Music.app', 'music', 'music'], ['Font Book.app', 'font-file', 'font-book'],
    ['Dictionary.app', 'document', 'dictionary'], ['Trash.app', 'trash', 'trash'],
  ];
  for (const [name, icon, appId] of requiredApps) {
    if (applications?.children && !applications.children.some((child) => child.appId === appId)) {
      applications.children.push(app(name, `/Applications/${name}`, icon, appId));
    }
  }
  if (guest?.children && !guest.children.some((child) => child.path === '/Users/Guest/.Trash')) {
    guest.children.push(folder('.Trash', '/Users/Guest/.Trash', 'trash', []));
  }
  if (documents?.children && !documents.children.some((child) => child.name === 'AquaOS Handbook.epub')) {
    documents.children.push(file('AquaOS Handbook.epub', '/Users/Guest/Documents/AquaOS Handbook.epub', 'document', '1.9 KB', null, today, '/documents/aquaos-handbook.epub', 'application/epub+zip'));
  }
  const resumeNode = getNode('/Users/Guest/Documents/Resume.pdf');
  if (resumeNode) Object.assign(resumeNode, { content: '/documents/resume.pdf', mimeType: 'application/pdf', size: '225 KB' });
  const handbook = getNode('/Users/Guest/Documents/AquaOS Handbook.epub');
  if (handbook) Object.assign(handbook, { content: '/documents/aquaos-handbook.epub', mimeType: 'application/epub+zip', size: '1.9 KB' });
  const movies = getNode('/Users/Guest/Movies');
  const oldMovie = movies?.children?.find((child) => child.name === 'desktop-tour.mov');
  if (oldMovie) {
    oldMovie.name = 'desktop-tour.mp4'; oldMovie.content = '/media/desktop-tour.mp4'; oldMovie.mimeType = 'video/mp4'; oldMovie.size = '1.6 MB';
    rewritePaths(oldMovie, '/Users/Guest/Movies/desktop-tour.mp4');
  }
  const music = getNode('/Users/Guest/Music');
  const oldAudio = music?.children?.find((child) => child.name === 'boot-chime.aiff');
  if (oldAudio) {
    oldAudio.name = 'boot-chime.mp3'; oldAudio.content = '/media/boot-chime.mp3'; oldAudio.mimeType = 'audio/mpeg'; oldAudio.size = '24 KB';
    rewritePaths(oldAudio, '/Users/Guest/Music/boot-chime.mp3');
  }
}

export { ensureSystemNodes };
